import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Img from 'react-image';

const Header = styled.div`
  font-weight: ${props => props.theme.fontWeight.bold};
`;

const Image = styled(Img)`
  display: block;
  width: 100%;
  border-radius: 50%;
`;

const ImageWrapper = styled.div`
  width: 42px;
  margin: 0 16px 0 0;
  overflow: hidden;

  @media (max-width: ${props => props.theme.deviceWidth.mobilePhone}) {
    display: none;
  }
`;

const Link = styled.a`
  color: ${p => p.theme.color.textPrimary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeight.regular};
  text-decoration: none;
  transition: color 180ms ease-in-out;

  &:hover {
    color: ${p => p.theme.color.primary};
  }
`;

const Text = styled.div`
  color: ${props => props.theme.color.textPrimary};
  font-family: ${props => props.theme.font.montserrat};
  font-size: 16px;
  line-height: 1;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 2px;
`;

const ResultPane = ({ rep }) => (
  <Wrapper>
    <ImageWrapper>
      <Image
        src={[
          rep.imageUrl,
          'https://s3.amazonaws.com/lochinvar-material/images/lochinvar_avatar.svg'
        ]}
        alt={rep.name || rep.companyName}
      />
    </ImageWrapper>
    <Text>
      {rep.name && <Header>{rep.name}</Header>}
      {rep.companyName && <Header>{rep.companyName}</Header>}
      {rep.address && <div>{rep.address}</div>}
      {rep.address1 && <div>{rep.address1}</div>}
      {rep.address2 && <div>{rep.address2}</div>}
      {rep.city && rep.state && rep.postalCode && (
        <div>{`${rep.city}, ${rep.state} ${rep.postalCode}`}</div>
      )}
      {rep.phone && (
        <div>
          <Link href={`tel:${rep.phone}`}>{rep.phone}</Link>
        </div>
      )}
    </Text>
  </Wrapper>
);

ResultPane.propTypes = {
  rep: PropTypes.object
};

export default ResultPane;
